import script from "./UserGroupManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGroupManagementView.vue?vue&type=script&setup=true&lang=js"

import "./UserGroupManagementView.vue?vue&type=style&index=0&id=3a169338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a169338"]])

export default __exports__